import { render, staticRenderFns } from "./OwnerAdminPanel.vue?vue&type=template&id=9a84f284"
import script from "./OwnerAdminPanel.vue?vue&type=script&lang=js"
export * from "./OwnerAdminPanel.vue?vue&type=script&lang=js"
import style0 from "./OwnerAdminPanel.vue?vue&type=style&index=0&id=9a84f284&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports